import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LoadingBar from 'react-redux-loading-bar';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Toaster from '../Toaster';
import AdminNavigation from '../siteadmin/AdminNavigation';
import { toggleAdminMenu } from '../../actions/siteadmin/modalActions';
import s from './AdminHeader.css';

const AdminHeader = ({ borderLess, toggleAdminMenu, isOpenMenu }) => {

  let borderClass;
  if (borderLess) {
    borderClass = s.rentAllHeaderBorderLess;
  }

  return (
    <div>
      <Toaster />
      <LoadingBar />
      <header className={cx(s.adminHeaderContainer, 'adminHeaderContainerRtl', 'hidden-print')}>
        <div className={s.adminHeaderMenuIcon} onClick={() => toggleAdminMenu(!isOpenMenu)}>
          <div className={s.hamburger}  >
            <span className={s.iconBar}></span>
            <span className={s.iconBar}></span>
            <span className={s.iconBar}></span>
          </div>
        </div>
        <AdminNavigation />
      </header>
    </div>
  );
}

AdminHeader.propTypes = {
  borderLess: PropTypes.bool,
};

AdminHeader.defaultProps = {
  borderLess: false,
};

const mapState = (state) => ({
  isOpenMenu: state?.modalStatus?.isOpenAdminMenu,
});

const mapDispatch = {
  toggleAdminMenu
};

export default withStyles(s)(connect(mapState, mapDispatch)(AdminHeader));